import { Button, Divider, Form, Input } from 'antd';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDpiaContext } from '../dpia.context';

const Step0 = ({ form, ...props }) => {
    const { t } = useTranslation(['translation', 'dpia']);
    const navigate = useNavigate(); 
    const onNextStep = () => {
        form.validateFields().then((value) => {
            props.form1.setFieldValue('dpiaName', value.dpiaName);
            props.goToStep(2);
        });
    };
    const {
        stepNo,
        setStepNo
    } = useDpiaContext();

    useEffect(() => {
        setStepNo(0)
    }, [navigate]); 



    return (
        <div
            hidden={!props?.isActive}
            className="mt-4 bg-white rounded-md p-6 overflow-hidden"
        >
            <Form layout="vertical" name="initForm" form={form}>
                <div className="font-semibold text-2xl text-purple-PHX">
                    {t('Data Protection Impact Assessment', {
                        ns: 'dpia',
                    })}
                </div>
                <div className="mt-4">
                    <div className="font-semibold">
                        {t('Data Protection Impact Assessment - DPIA', {
                            ns: 'dpia',
                        })}
                    </div>
                    <div>
                        {t('Data Protection Impact Assessment Detail', {
                            ns: 'dpia',
                        })}
                    </div>
                    <div className="mt-4">
                        {parse(
                            t(
                                'Data Protection Impact Assessment Detail on WhitFact',
                                {
                                    ns: 'dpia',
                                }
                            )
                        )}
                    </div>
                </div>
                <Divider />
                <Form.Item
                    className="grid grid-cols-2"
                    label={t(
                        'Name of the Personal Data Protection Impact Assessment (DPIA) Form',
                        {
                            ns: 'dpia',
                        }
                    )}
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="dpiaName"
                >
                    <Input
                        className="col-span-1"
                        size="large"
                        showCount
                        maxLength={100}
                        placeholder={t('Specify the assessment name', {
                            ns: 'dpia',
                        })}
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        onClick={onNextStep}
                        size="large"
                        type="primary"
                        className="px-8"
                    >
                        {t('Start')}
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default Step0;
